import { render, staticRenderFns } from "./editTemplateDialog.vue?vue&type=template&id=0b0fffc8&scoped=true&"
import script from "./editTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./editTemplateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./editTemplateDialog.vue?vue&type=style&index=0&id=0b0fffc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0fffc8",
  null
  
)

export default component.exports